"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceOracleInterface = exports.getDeployedPriceOracleContract = exports.CHAINS_WITH_PRICE_ORACLES = exports.getContractDeployments = void 0;
const utils_1 = require("ethers/lib/utils");
const deployments_json_1 = __importDefault(require("@connext/nxtp-contracts/deployments.json"));
const ConnextPriceOracle_json_1 = __importDefault(require("@connext/nxtp-contracts/artifacts/contracts/ConnextPriceOracle.sol/ConnextPriceOracle.json"));
/**
 * Helper to allow easy mocking
 */
const getContractDeployments = () => {
    return deployments_json_1.default;
};
exports.getContractDeployments = getContractDeployments;
/**
 * A number[] list of all chain IDs on which a Connext Price Oracle Contracts
 * have been deployed.
 */
exports.CHAINS_WITH_PRICE_ORACLES = (() => {
    const chainIdsForGasFee = [];
    const _contractDeployments = exports.getContractDeployments();
    Object.keys(_contractDeployments).forEach((chainId) => {
        var _a, _b;
        const record = _contractDeployments[chainId];
        const chainName = Object.keys(record)[0];
        if (chainName) {
            const priceOracleContract = (_b = (_a = record[chainName]) === null || _a === void 0 ? void 0 : _a.contracts) === null || _b === void 0 ? void 0 : _b.ConnextPriceOracle;
            if (priceOracleContract) {
                chainIdsForGasFee.push(parseInt(chainId));
            }
        }
    });
    return chainIdsForGasFee;
})();
/**
 * Returns the address of the Connext Price Oracle contract deployed on the
 * given chain ID; returns undefined if no such contract has been deployed.
 *
 * @param chainId - The chain you want the address on.
 *
 * @returns The deployed address or undefined if the contract has not yet been
 * deployed.
 */
const getDeployedPriceOracleContract = (chainId) => {
    var _a, _b, _c;
    const _contractDeployments = exports.getContractDeployments();
    const record = (_a = _contractDeployments[chainId.toString()]) !== null && _a !== void 0 ? _a : {};
    const name = Object.keys(record)[0];
    if (!name) {
        return undefined;
    }
    const contract = (_c = (_b = record[name]) === null || _b === void 0 ? void 0 : _b.contracts) === null || _c === void 0 ? void 0 : _c.ConnextPriceOracle;
    return contract ? { address: contract.address, abi: contract.abi } : undefined;
};
exports.getDeployedPriceOracleContract = getDeployedPriceOracleContract;
/**
 * Convenience method for initializing an Interface object for the Connext
 * Price Oracle contract ABI.
 *
 * @returns An ethers Interface object initialized with the Connext Price
 * Oracle ABI.
 */
const getPriceOracleInterface = () => new utils_1.Interface(ConnextPriceOracle_json_1.default.abi);
exports.getPriceOracleInterface = getPriceOracleInterface;
//# sourceMappingURL=contracts.js.map